import { useContext, useEffect, useState } from 'react';

import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import { ProjectContext } from 'containers/GlobalWrapper/ProjectDataValidation';
import { authorizations, PROJECT_USER_ROLE } from 'utils/constants';
import localStorageUser from 'utils/localStorageUser';

const useCurrentUser = () => {
  const currentProject = useContext(ProjectContext);
  const currentOrganization = useContext(OrganizationContext);

  const [projectRole, setProjectRole] = useState(null);
  const [isOrgaAdmin, setIsOrgaAdmin] = useState(undefined);

  useEffect(
    () => {
      if (!currentProject?.authorizations) return;
      if (currentProject.authorizations.includes(authorizations.project.delete)) {
        setProjectRole(PROJECT_USER_ROLE.admin);
      } else if (currentProject.authorizations.includes(authorizations.project.readSettings)) {
        setProjectRole(PROJECT_USER_ROLE.editor);
      } else if (currentProject.authorizations.includes(authorizations.project.changeUserRole)) {
        setProjectRole(PROJECT_USER_ROLE.limitedEditor);
      } else {
        setProjectRole(PROJECT_USER_ROLE.guest);
      }
    },
    [currentProject?.authorizations],
  );

  useEffect(
    () => {
      if (!currentOrganization?.authorizations) return;
      setIsOrgaAdmin(
        currentOrganization.authorizations.includes(authorizations.organization.delete),
      );
    },
    [currentOrganization?.authorizations],
  );

  const userId = localStorageUser.getCurrentUserId();
  const email = localStorageUser.getCurrentUserEmail();
  const name = localStorageUser.getCurrentUserName();

  return {
    userId,
    email,
    name,
    projectRole,
    isOrgaAdmin,
  };
};

export default useCurrentUser;
